export default __webpack_public_path__ + "a548614b5ccdf41c768c88c42030a60e.png";